<div class="p-2">
  <ngx-masonry [options]="masonryOptions" [ordered]="true">
    <div class="grid-sizer w-full sm:w-[50%] md:w-[25%] lg:w-[20%]"></div>
    @for (item of imageItems; track item; let index = $index) {
      <div class="masonry-item w-full sm:w-[50%] md:w-[25%] lg:w-[20%]" ngxMasonryItem>
        <img (click)="onOpen(index)" [alt]="item.caption" [src]="item.thumb" class="cursor-pointer" />
        @if (isMasonryWithLabel()) {
          <div class="absolute bottom-0 left-0 right-0 p-2 bg-white/[.80]">
            {{ item.caption }}
          </div>
        }
      </div>
    }
  </ngx-masonry>
</div>
